import { PublicCustomerFactory } from './public-customer.factory';
import { UserFactory } from './user.factory';
import { RoleFactory } from './role.factory';
import { CustomerFactory } from './customer.factory';

export const MODEL_FACTORIES = [
  UserFactory,
  RoleFactory,
  CustomerFactory,
  PublicCustomerFactory,
];



// WEBPACK FOOTER //
// ./src/app/resources/factories/index.ts